import React, { useState, useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../fontawesome/fontawesome';


import './image.css';

export default function Image(props) {
	const [image, setImage] = useState(null);

	useEffect(() => {
	}, []);

	function openImage() {
		setImage(props.src);
	}

	async function downloadImage() {
		try {
			const response = await fetch(image);
			const blob = await response.blob();
			const blobUrl = URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = blobUrl;
			link.download = image.split('/').pop();
			link.click();
			URL.revokeObjectURL(blobUrl);
		} catch (error) {
			console.error('Error downloading the image:', error);
		}
	};

	function close() {
		setImage(null);
	}

	return (
		<>
			{image !== null &&
				<>
					<div className="enlarge-image-top text-mcenter" /*onClick={()=>close()}*/>
						<div className="enlarge-image-close ">
							<div className="text-rcenter">
								<FontAwesomeIcon size="2x" icon="download" style={{paddingRight: 15}} onClick={()=>downloadImage()} />
								<FontAwesomeIcon size="3x" icon="xmark" onClick={()=>close()} />
							</div>
						</div>
						<div className="enlarge-divider"></div>
					</div>
					<div className="enlarge-image-bottom text-mcenter" onClick={()=>close()}>
						<img src={image} style={{cursor: 'pointer'}} alt="Preview" />
				</div>
				</>
			}
			<img src={props.src} alt={props.alt} className={props.className} width={props.width} height={props.height} onClick={()=>openImage()} style={{cursor: 'pointer'}} />
		</>
	);
}
